import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useState, useMemo } from 'react';
import './index.scss';
import { Bubble, Dropdown, List } from 'tea-component';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import GameImage from '@/pages/home/components/GameImage';
import { addV2Prefix } from '@/pages/intelligence/utils/commonUtils';
import TipOne from '@/pages/intelligence/assets/svg/tipicon/tip-one.svg';
import TipTwo from '@/pages/intelligence/assets/svg/tipicon/tip-two.svg';
import TipThree from '@/pages/intelligence/assets/svg/tipicon/tip-three.svg';
import TableImage from '@/pages/intelligence/components/TableComponents/components/TableImage';
import TextBubblesDbi from '@/pages/intelligence/components/TextBubblesDbi';
import _ from 'lodash-es';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { useIntl } from 'umi';
interface GameCvmType {
  /** 头像src */
  img: string;
  /** 竖着头像图标 */
  icon?: any; // ??
  cover?: any; // ??
  /** 标题 */
  gametitle: string;
  name?: string;
  /** 主题标题 */
  isDatabrain?: string;
  databrainIconTip?: React.ReactNode;
  /** 文字前面的图标列表 */
  iconList?: any[];
  /** 国家图标 */
  countryIcon?: string;
  /** 描述 */
  text?: React.ReactNode;
  // 描述是否有气泡
  hasTextBubble?: boolean;
  /** 描述提示列表 */
  tipList?: any[];
  /* 前面图标 */
  frontIcon?: string;
  /** 类名*/
  className?: string;
  imgType?: string; // 默认是正方形圆角 1是横向长方形 2是纵轴长方形
  customIcon?: string | null | React.ReactNode;
  entityIcon?: string | null | React.ReactNode;
  subInfoBubbleContent?: React.ReactNode;
}
interface FirstRowProps {
  cvm: GameCvmType;
  renderDom?: React.ReactNode;
  /** id显示 如排名 */
  id?: number | string;
  // 排名是否有徽章效果，详见genre profile - insights - Market CR10 By Revenue
  hasBadge?: boolean;
  // 是否需要展示图片。默认展示图片
  showImg?: boolean;
  /** 是否显示下拉，下拉显示的数据 */
  popupData?: any[];
  className?: string;
  imgType?: string;
  /** 右键游戏跳转新链接 */
  rihgtClickToJumpHref?: string;
  onClick?: (...args: any[]) => void;
  // 下拉点击回调
  onDropdown?: (...args: any[]) => void;
  // 是否展示用户头像
  showUserImg?: boolean;
  // 是否展示整体hover提示内容
  ifNeedFirstRowBubble?: boolean;
  firstRowBubbleContent?: string;
  hasReleaseTime?: boolean;
  // icon右侧的dom
  iconRightDom?: React.ReactElement | null;
}

const RANK_ICONS = [TipOne, TipTwo, TipThree];
const FirstRow = (props: FirstRowProps) => {
  const {
    showImg = true,
    showUserImg = false,
    cvm,
    id,
    hasBadge,
    popupData,
    rihgtClickToJumpHref,
    className,
    onClick,
    onDropdown,
    ifNeedFirstRowBubble = false,
    firstRowBubbleContent = '',
    renderDom,
    imgType = '', // 从组件传入类型,非游戏cvm传入
    hasReleaseTime = true,
    iconRightDom,
  } = props;
  // console.debug('FirstRowFirstRow', props);
  const rank = Number(id);
  const { formatMessage } = useIntl();

  const imgTypeCur = useMemo(() => {
    return imgType != '' ? imgType : cvm?.imgType;
  }, [imgType, cvm]);

  const [openDropdown, setOpenDropdown] = useState(false);

  const jumpClassCur = useMemo(() => {
    if (rihgtClickToJumpHref) {
      return 'dbi-no-jump-class';
    }
    return '';
  }, [imgTypeCur]);

  return (
    <ARightClickToJump href={addV2Prefix(rihgtClickToJumpHref)} style={{ display: 'inline' }} className={jumpClassCur}>
      <Bubble
        arrowPointAtCenter
        dark
        style={{ maxWidth: 346 }}
        content={ifNeedFirstRowBubble ? firstRowBubbleContent : ''}
      >
        <div
          className={`dbi-firstRow-flex ${className ? className : ''}`}
          onClick={() => {
            if (onClick instanceof Function) {
              onClick();
            }
          }}
        >
          {id ? (
            rank && hasBadge ? (
              <div className="dbi-gameinfocont-rank">
                {rank > 0 && rank <= 3 ? (
                  <img src={RANK_ICONS[rank - 1]} alt="" />
                ) : (
                  <span>{rank}</span>
                )}
              </div>
            ) : (
              <span className="dbi-text-id">{id}</span>
            )
          ) : (
            ''
          )}
          {cvm?.frontIcon ? <img src={cvm?.frontIcon} className="dbi-firstRow-front" /> : ''}
          {showImg && (
            <GameImage
              src={cvm?.img || cvm?.cover}
              entityType={imgTypeCur}
              className={
                imgTypeCur == 'pc'
                  ? 'dbi-firstRow-imgtwo'
                  : imgTypeCur === 'mobile'
                    ? 'dbi-firstRow-imgone'
                    : (cvm?.icon && imgTypeCur !== 'company') ||
                      imgTypeCur == 'console' ||
                      imgTypeCur == 'combine'
                      ? 'dbi-firstRow-imgthere big-img '
                      : 'dbi-firstRow-imgone'
              }
            />
          )}
          {/* streaming-influencer 需要展示带loading的头像 TableImage组件 */}
          {showUserImg && <TableImage src={cvm?.img || cvm?.cover} />}
          <div className="dbi-firstRow-gametitle">
            {renderDom ? (
              renderDom
            ) : (
              <div className="dbi-firstRow-gametitle-flex">
                <a
                  className={`dbi-firstRow-title ${(!cvm?.countryIcon || cvm?.countryIcon == '') && (!cvm?.text || cvm?.text == '')
                    ? 'dbi-firstRow-title-only'
                    : ''
                    }`}
                >
                  {!_.isEmpty(popupData) ? (
                    <Dropdown
                      className={`dbi-firstRow-title-dropdown ${openDropdown ? 'dropdown-open' : ''
                        }`}
                      trigger="click"
                      placementOffset={[0, 0]}
                      clickClose={false}
                      button={cvm?.gametitle || cvm?.name}
                      onOpen={() => setOpenDropdown(true)}
                      onClose={() => setOpenDropdown(false)}
                    >
                      <List type="option">
                        {popupData?.map((item: any) => (
                          <List.Item
                            onClick={() => {
                              onDropdown?.(item);
                              setOpenDropdown(false);
                            }}
                            key={item.value}
                          >
                            {item.text}
                          </List.Item>
                        ))}
                      </List>
                    </Dropdown>
                  ) : (
                    <span>{cvm?.gametitle || cvm?.name}</span>
                  )}
                </a>
              </div>
            )}

            <div className="dbi-firstRow-right">
              {cvm?.iconList ? (
                <div className="dbi-firstRow-desc">
                  {cvm?.iconList.map((item: any, index: number) => (
                    <SvgIcon key={index} type={item} className="dbi-firstRow-desc-svg" />
                  ))}
                </div>
              ) : (
                ''
              )}
              {cvm?.customIcon ? cvm?.customIcon : null}
              {cvm?.subInfoBubbleContent ? (
                <Bubble
                  className="dbi-firstRow-bubble dbi-firstRow-publisher-bubble"
                  dark
                  arrowPointAtCenter
                  content={cvm?.subInfoBubbleContent}
                >
                  <span className="dbi-firstRow-subinfo dbi-firstRow-subinfo-hover">
                    {cvm?.countryIcon && <img src={cvm?.countryIcon} className="dbi-firstRow-svg" />}
                    {hasReleaseTime && cvm?.text && (
                      <span className="dbi-firstRow-text">{cvm?.text}</span>
                    )}
                  </span>
                </Bubble>
              ) : (
                <>
                  {cvm?.countryIcon ? <img src={cvm?.countryIcon} className="dbi-firstRow-svg" /> : ''}
                  {hasReleaseTime && cvm?.text ? (
                    cvm?.hasTextBubble ? (
                      <Bubble className="dbi-firstRow-bubble" dark content={cvm?.text}>
                        <span className="dbi-firstRow-text">{cvm?.text}</span>
                      </Bubble>
                    ) : (
                      <TextBubblesDbi isSubText text={cvm?.text} />
                    )
                  ) : (
                    ''
                  )}
                </>
              )}
              {!hasReleaseTime && <span className='dbi-firstRow-title' style={{ flex: '0 0 auto' }}><span className='dbi-add-entities-first-row-comp'>{cvm?.gameEntityNode}</span></span>}
              {cvm?.tipList ? (
                <span className="dbi-firstRow-box">
                  {cvm?.tipList?.map((e: any, i: any) => (
                    <span
                      className={`dbi-firstRow-text-tip ${cvm?.text === '' ? 'dbi-firstRow-text-none' : ''
                        }`}
                      key={i}
                    >
                      {e}
                    </span>
                  ))}
                </span>
              ) : (
                ''
              )}
              {/* 主题图标， 以防icon不一样，所以传入 */}
              {cvm?.isDatabrain ? (
                <Bubble
                  style={{ maxWidth: 400 }}
                  className="dbi-firstRow-bubble"
                  dark
                  content={cvm?.databrainIconTip}
                >
                  <label className="dbi-firstRow-themeBtnafter">
                    <img src={cvm?.isDatabrain} className="dbi-firstRow-theme" />
                  </label>
                </Bubble>
              ) : null}
            </div>
            {(!!cvm?.icon || !!cvm?.entityIcon) && (
              // cvm?.icon 为数组，按数组方式渲染
              <div className="dbi-firstRow-icon">
                {!!cvm?.entityIcon ? cvm?.entityIcon : null}
                {!!cvm?.entityIcon && !!cvm?.icon?.length && (
                  <span className="dbi-firstRow-split"></span>
                )}
                {Array.isArray(cvm?.icon) &&
                  cvm?.icon
                    ?.filter((item) => !!item)
                    ?.map((item: any, index: number) => {
                      return item === 'pcdevice' ? (
                        <Bubble dark content={formatMessage({ id: 'dbi_pcdevice_icon_tooltips' })}>
                          <img
                            src={getDataSourceIcon('pcdevice')}
                            className="dbi-firstRow-show"
                            key={index}
                          />
                        </Bubble>
                      ) : (
                        <img src={item} className="dbi-firstRow-show" key={index} />
                      );
                    })}
                {/* 否则按单个icon方式渲染 */}
                {typeof cvm?.icon === 'string' && (
                  <img src={cvm?.icon} className="dbi-firstRow-show" key={cvm?.icon} />
                )}
                {iconRightDom}
              </div>
            )}
          </div>
        </div>
      </Bubble>
    </ARightClickToJump>
  );
};

export default FirstRow;
